export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/monster-2-a04c14ca5a7b4793047571907e96059a.png";